import {
  create_company_staff,
  update_company_staff,
  delete_company_staff,
  recover_company_staff,
  query_company_staff_list,
} from '@/api/jms-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/jms/jms-companystaff-config';

import { reactive } from 'vue';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '员工编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写员工编号',
    },
    {
      type: 'input',
      name: 'name',
      label: '员工姓名',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写名称',
    },
    {
      type: 'remoteselect',
      name: 'person_id',
      label: '绑定登录账号',
      disabled: false,
      valueKey: 'id',
      labelKey: 'realname',
      placeholder: '请选择绑定登录账号',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'liyu_organization-person',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '员工姓名',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写名称',
    },
    {
      type: 'input',
      name: 'code',
      label: '公司员工编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写公司员工编号',
    },
    {
      type: 'remoteselect',
      name: 'person_id',
      label: '绑定登录账号',
      disabled: false,
      valueKey: 'id',
      labelKey: 'realname',
      placeholder: '请选择绑定登录账号',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'liyu_organization-person',
    },
  ],
  rules: {
    name: [{ required: true, message: '请填输入名称' }],
    code: [{ required: true, message: '请填输入公司员工编号' }],
    person_id: [{ required: true, message: '请填输入绑定登录账号' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    person_id: null,
    code: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  },
  fields: [
    {
      type: 'input',
      name: 'name',
      label: '员工姓名',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写名称',
    },
    {
      type: 'input',
      name: 'code',
      label: '公司员工编码',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写公司员工编码',
    },
    {
      type: 'remoteselect',
      name: 'person_id',
      label: '绑定登录账号',
      disabled: false,
      valueKey: 'id',
      labelKey: 'realname',
      placeholder: '请选择绑定登录账号',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'liyu_organization-person',
    },
  ],
  rules: {
    person_id: [{ required: true, message: '请填输入绑定登录账号' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    code: null,
    person_id: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '公司员工管理',
  addModalTitle: '新建公司员工',
  updateTitle: '修改公司员工',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    area_id: 'id',
  },
  delete: {
    area_id: 'id',
  },
  recover: {
    area_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    area_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
  },
  {
    title: '员工编号',
    dataIndex: 'code',
    checked: true,
  },
  {
    title: '员工姓名',
    dataIndex: 'name',
    checked: true,
  },
  {
    title: '绑定登录账号',
    dataIndex: 'person_phone',
    checked: true,
  },
  {
    title: '绑定登录名称',
    width: 150,
    dataIndex: 'person_name',
    checked: true,
  },
  {
    title: '操作',
    width: 200,
    dataIndex: 'action',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_company_staff_list,
    addData: create_company_staff,
    updateData: update_company_staff,
    removeData: delete_company_staff,
    recoverData: recover_company_staff,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
